<template>
    <div>
        <div class="content-wrapper" v-if="list">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('Suppliers_list')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button type="button" class="btn btn-success btn-with-shadow" @click="exportAll">
                            {{ $t('export_all') }}
                        </button>
                        <button type="button" class="btn btn-primary btn-with-shadow" @click="redirectToAdd">
                            {{ $t('add') }}
                        </button>

                    </div>
                </div>
            </div>

            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />

            <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="demo-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
        </div>
    </div>

</template>


<script>
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl.js";
import { tableSuppliers } from './mixins/tableSuppliers.js';
import { COMPANIES_EXPORT } from "../../../Config/ApiUrl.js";
import { urlGenerator } from "../../../Helpers/AxiosHelper.js";

export default {
    extends: CoreLibrary,
    mixins: [tableSuppliers],
    data() {
        return {
            COMPANIES_EXPORT,
            list: true,
            addCompany: false,
            selectedUrl: '',
            deleteConfirmationModalActive: false,
            postcustomer: false,
            deleteLoader: false,
            tableId: 'advance-table',
            rowData :{},
            options: {
                name: 'AdvanceTable',
                url: actions.SUPPLIERS_DATA,
                showHeader: true,
                enableHighlights: true,
                enableSaveFilter: true,
                columns: [], // Columnas inicialmente vacías
                actions: [
                    // /companies/list
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'none',
                        component: 'companies-tabs',
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'demo-delete',
                    }
                ],
                filters: [
                    // {
                    //     title: this.$t('date'),
                    //     type: "range-picker",
                    //     key: "date",
                    //     option: ["today", "thisMonth", "last7Days", "nextYear"]
                    // },
                    // {
                    //     title: this.$t('search_and_select'),
                    //     type: "search-and-select-filter",
                    //     key: "serverside_select",
                    //     settings: {
                    //         url: actions.COMPANIES_SEARCH_SELECT,
                    //         modifire: (v) => ({ id: v.id, name: v.name }),
                    //         per_page: 10,
                    //         queryName: 'search_selectable',
                    //         loader: 'app-pre-loader',
                    //         multiple: true,
                    //         params: {
                    //             'type': 'type1',
                    //             'isWanted': true
                    //         }
                    //     },
                    //     listValueField: 'name'
                    // },
                ],
                showFilter: false,
                showSearch: true,
                showCount: false,
                showClearFilter: false,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            },

        };
    },

    computed: {

    },
    created() {

        this.options.columns = this.tableColumns; // Asignar las columnas de la tabla
    },
    methods: {


        closeAddEditModal() {
            $("#edit-companies-list").modal('hide');
            $("#edit-companies-list").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();
        },
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },


        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                //almacena informacion de las columnas
                localStorage.removeItem('DataAddressEdit');
                localStorage.removeItem('DataContactsEdit');
                localStorage.removeItem('DataCompaniesEdit');
                localStorage.removeItem('DataCompanies');
                localStorage.removeItem('DataContact');
                localStorage.removeItem('DataAddress');

                this.saveDataStores(this.rowData)
            }
        },

        saveDataStores(rowData) {
            // address 
            //(rowData);
            
            let address = rowData.addresses;
            let storedAddresses = JSON.parse(localStorage.getItem('DataAddressEdit')) || [];
            storedAddresses.push(...address);
            localStorage.setItem('DataAddressEdit', JSON.stringify(storedAddresses));

            // contacts 
            let contact = rowData.contacts;
            let storeContacts = JSON.parse(localStorage.getItem('DataContactsEdit')) || [];
            storeContacts.push(...contact);
            localStorage.setItem('DataContactsEdit', JSON.stringify(storeContacts));

            // company
            const excludeKeys = ['addresses', 'contacts'];

            // Filtrar las propiedades del objeto que no están en `excludeKeys`
            const filteredData = Object.fromEntries(
                Object.entries(rowData).filter(([key]) => !excludeKeys.includes(key))
            );

            localStorage.setItem('DataCompaniesEdit', JSON.stringify(filteredData));
            this.list = false;


            let selectedUrl = `${actions.SUPPLIERS_DATA}/${rowData.id}`


            this.$router.push({
                name: 'companies-details',
                query: { selectedUrl: selectedUrl }
            });

        },

        confirmed() {
            let url = `${actions.COMPANIESRESOURCES}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        exportAll() {
            const exportUrl = urlGenerator(COMPANIES_EXPORT, 'Type=supplier');
            window.location.replace(exportUrl);
        },
        
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },

        redirectToAdd() {
            const base_url = localStorage.getItem("base_url");
            window.location.href = `${base_url}/suppliers/adding?tab=suppliers+information`;
        },
    },
    watch: {
        selectedUrl(newVal) {
            this.localSelectedUrl = newVal; // Actualiza la propiedad de datos cuando la prop cambia
        }
    },


    mounted() {
        localStorage.removeItem('DataAddressEdit');
        localStorage.removeItem('DataContactsEdit');
        localStorage.removeItem('DataCompaniesEdit');
        

        localStorage.removeItem('DataCompanies');
        localStorage.removeItem('DataContact');
        localStorage.removeItem('DataAddress');

        localStorage.removeItem('DataSupplier');
        localStorage.removeItem('ContactSupplier');
        localStorage.removeItem('AddressSupplier');

    }
}
</script>
